import swal from "sweetalert";
import axiosInstance from "../api";

  export const onboardingDetailsAdd = (data, setLoading,navigate,setActiveStep,activeStep) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("zatca/add_zatca", data);
      if (response?.data?.status) {
        setActiveStep(activeStep + 1)
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };





